
import { canOfferNewsletter } from '~/utils/newsletterOffer'

export default {
  name: 'FooterTop',
  computed: {
    showNewsletterForm() {
      return canOfferNewsletter(this.$auth.user)
    },
    newsletterSubtitleKey() {
      return this.$store.getters.is_pro_plus
        ? 'components.footerTop.newsletterSubtitleProPlus'
        : 'components.footerTop.newsletterSubtitle'
    },
  },
}
